import BaseDB from 'libs/DB/BaseDB'

// v2: 익스텐션이 버전 없이 열어 만든 store 없는 빈 DB(v1)를 업그레이드로 복구한다.
// 익스텐션이 또 빈 DB 를 만들어도 항상 v1 이라 이 버전이 이긴다.
const dataDB = new BaseDB('orgChartDB', {
  version: 2,
  key: 'id',
  expireDuration: null,
  checkForList: (item, key) => {
    if (typeof key === 'number' || key.indexOf('info') !== 0) {
      return true
    }
    return false
  },
})

export default dataDB
